import EditorBox from 'components/write/EditorBox';
import React from 'react';

const Write = () => {
  return <EditorBox />;
};

export default Write;
